"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var watchFile_exports = {};
__export(watchFile_exports, {
  _registerWatchFileImpl: () => _registerWatchFileImpl,
  watchFile: () => watchFile
});
module.exports = __toCommonJS(watchFile_exports);
var WATCH_FILE_KEY = "__oneWatchFile";
function watchFile(path) {
  if (typeof window !== "undefined") return;
  var impl = globalThis[WATCH_FILE_KEY];
  if (impl) {
    impl(path);
  }
}
function _registerWatchFileImpl(impl) {
  globalThis[WATCH_FILE_KEY] = impl;
}
//# sourceMappingURL=watchFile.js.map
